interface ImportMetaEnv {
    readonly HTTP_BASE: string;
    readonly HTTP_PORT: string;
    readonly APP_SECRET: string;
    readonly API_SERVER: string;
    readonly TIME_ZONE: string;
}

export const CONFIG: ImportMetaEnv = {
    HTTP_BASE: import.meta.env.HTTP_BASE ?? '',
    HTTP_PORT: import.meta.env.HTTP_PORT ?? '4000',
    APP_SECRET: import.meta.env.APP_SECRET ?? 'play.http.secret.key',
    API_SERVER: import.meta.env.API_SERVER ?? 'http://localhost:8080',
    TIME_ZONE: import.meta.env.TIME_ZONE ?? 'Etc/UTC',
};
